import LoginButtonTemplate from "./LoginButtonTemplate";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import useKakaoLogin from "../../hooks/useKakaoLogin";
import useMixpanelWeb from "hooks/useMixpanelWeb";

export default function KakaoLoginButton({
  render,
  onNotCoach,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
  onNotCoach?: () => void;
}) {
  const handleLogin = useKakaoLogin();
  const user = useRecoilValue(userAtom);

  const trackLoginButtonClick = useMixpanelWeb({
    eventName: "로그인 버튼 클릭",
    params: { method: "kakao" },
  });

  return (
    <LoginButtonTemplate
      loginType="kakao"
      action={() => {
        trackLoginButtonClick();
        handleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
      widthPx={320}
    />
  );
}
